export enum DragAndDropDialogProperties {
  dialogFilePreviewWidth = '650px',
}
